/**
 * What the Pipeline toolbar renders before the server has answered, and the
 * server template its Backshop layout asks for. Kept apart from the service so a
 * test that replaces the service still has the constants.
 */
import type { PipelineExportSettings } from './pipelineExportSettings'

/** The server template the Backshop layout renders (backend/app/reporting/pipeline_backshop.py). */
export const BACKSHOP_TEMPLATE = 'pipeline_backshop'

/** The default layout: Backshop, with the legacy choices behind it untouched. */
export const DEFAULT_PIPELINE_EXPORT_SETTINGS: PipelineExportSettings = {
  layout: 'backshop',
  template: 'pipeline_summary',
  formats: ['pdf', 'xlsx'],
  useOnScreenColumns: true,
}
